export const SET_LOGO_COMPANY = 'SET_LOGO_COMPANY'
export const SET_NEW_EMAIL = 'SET_NEW_EMAIL'